function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-4"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-5"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-6"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-7"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-8"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Row-Menu",
  transform: "translate(-48.000000, -1190.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instagram-Gallery",
  transform: "translate(48.000000, 1190.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#CDD4DA",
  x: 0.5,
  y: 0.5,
  width: 159,
  height: 107
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(6.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-1)",
  id: "instagram-(1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,7.496 C11.4024979,8.86157728 10.7064207,10.2030756 9.47330122,10.8237391 C8.24018177,11.4444025 6.74803885,11.2042965 5.77187116,10.2281288 C4.79570348,9.25196115 4.55559747,7.75981823 5.17626092,6.52669878 C5.79692438,5.29357932 7.13842272,4.59750205 8.504,4.8 C9.89838141,5.00676924 10.9932308,6.10161859 11.2,7.496 Z",
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.4,
  y1: 3.6,
  x2: 12.408,
  y2: 3.6,
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(44.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-2)",
  id: "instagram-(1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,7.496 C11.4024979,8.86157728 10.7064207,10.2030756 9.47330122,10.8237391 C8.24018177,11.4444025 6.74803885,11.2042965 5.77187116,10.2281288 C4.79570348,9.25196115 4.55559747,7.75981823 5.17626092,6.52669878 C5.79692438,5.29357932 7.13842272,4.59750205 8.504,4.8 C9.89838141,5.00676924 10.9932308,6.10161859 11.2,7.496 Z",
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.4,
  y1: 3.6,
  x2: 12.408,
  y2: 3.6,
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(82.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-3)",
  id: "instagram-(1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,7.496 C11.4024979,8.86157728 10.7064207,10.2030756 9.47330122,10.8237391 C8.24018177,11.4444025 6.74803885,11.2042965 5.77187116,10.2281288 C4.79570348,9.25196115 4.55559747,7.75981823 5.17626092,6.52669878 C5.79692438,5.29357932 7.13842272,4.59750205 8.504,4.8 C9.89838141,5.00676924 10.9932308,6.10161859 11.2,7.496 Z",
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.4,
  y1: 3.6,
  x2: 12.408,
  y2: 3.6,
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(120.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-4)",
  id: "instagram-(1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,7.496 C11.4024979,8.86157728 10.7064207,10.2030756 9.47330122,10.8237391 C8.24018177,11.4444025 6.74803885,11.2042965 5.77187116,10.2281288 C4.79570348,9.25196115 4.55559747,7.75981823 5.17626092,6.52669878 C5.79692438,5.29357932 7.13842272,4.59750205 8.504,4.8 C9.89838141,5.00676924 10.9932308,6.10161859 11.2,7.496 Z",
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.4,
  y1: 3.6,
  x2: 12.408,
  y2: 3.6,
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(120.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-5)",
  id: "instagram-(1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,7.496 C11.4024979,8.86157728 10.7064207,10.2030756 9.47330122,10.8237391 C8.24018177,11.4444025 6.74803885,11.2042965 5.77187116,10.2281288 C4.79570348,9.25196115 4.55559747,7.75981823 5.17626092,6.52669878 C5.79692438,5.29357932 7.13842272,4.59750205 8.504,4.8 C9.89838141,5.00676924 10.9932308,6.10161859 11.2,7.496 Z",
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.4,
  y1: 3.6,
  x2: 12.408,
  y2: 3.6,
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(82.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-6)",
  id: "instagram-(1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,7.496 C11.4024979,8.86157728 10.7064207,10.2030756 9.47330122,10.8237391 C8.24018177,11.4444025 6.74803885,11.2042965 5.77187116,10.2281288 C4.79570348,9.25196115 4.55559747,7.75981823 5.17626092,6.52669878 C5.79692438,5.29357932 7.13842272,4.59750205 8.504,4.8 C9.89838141,5.00676924 10.9932308,6.10161859 11.2,7.496 Z",
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.4,
  y1: 3.6,
  x2: 12.408,
  y2: 3.6,
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(44.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-7)",
  id: "instagram-(1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,7.496 C11.4024979,8.86157728 10.7064207,10.2030756 9.47330122,10.8237391 C8.24018177,11.4444025 6.74803885,11.2042965 5.77187116,10.2281288 C4.79570348,9.25196115 4.55559747,7.75981823 5.17626092,6.52669878 C5.79692438,5.29357932 7.13842272,4.59750205 8.504,4.8 C9.89838141,5.00676924 10.9932308,6.10161859 11.2,7.496 Z",
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.4,
  y1: 3.6,
  x2: 12.408,
  y2: 3.6,
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-33",
  transform: "translate(6.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-8)",
  id: "instagram-(1)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#000000",
  strokeWidth: 1.6,
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2,7.496 C11.4024979,8.86157728 10.7064207,10.2030756 9.47330122,10.8237391 C8.24018177,11.4444025 6.74803885,11.2042965 5.77187116,10.2281288 C4.79570348,9.25196115 4.55559747,7.75981823 5.17626092,6.52669878 C5.79692438,5.29357932 7.13842272,4.59750205 8.504,4.8 C9.89838141,5.00676924 10.9932308,6.10161859 11.2,7.496 Z",
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.4,
  y1: 3.6,
  x2: 12.408,
  y2: 3.6,
  id: "Path",
  stroke: "#000000",
  strokeWidth: 1.6
})))))));

function SvgIconInstagramGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "108px",
    viewBox: "0 0 160 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Instagram Gallery 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagramGallery);
export default __webpack_public_path__ + "static/media/icon_instagram_gallery.1eca396c.svg";
export { ForwardRef as ReactComponent };